<template>
  <div class="shop__top-btn relative">
    <a id="share-btn" class="bordered-btn">
      <div class="flex">
        <div class="img_share"></div>
        <div class="share_text">{{ $t("Share") }}</div>
      </div>
    </a>
    <div id="share-buttons" class="socials">
      <!-- Facebook -->
      <a
        :href="'https://www.facebook.com/sharer.php?u=' + window.location.href"
        class="facebook"
        target="_blank"
      >
        <i class="fab fa-facebook-f"></i>
      </a>
      <!-- LinkedIn -->
      <a
        :href="
          'https://www.linkedin.com/sharing/share-offsite/?url=' +
          window.location.href
        "
        class="lin"
        target="_blank"
      >
        <i class="fab fa-linkedin-in"></i>
      </a>
      <!-- Pinterest -->
      <a
        class="pinterest"
        href="javascript:void((function()%7Bvar%20e=document.createElement('script');e.setAttribute('type','text/javascript');e.setAttribute('charset','UTF-8');e.setAttribute('src','https://assets.pinterest.com/js/pinmarklet.js?r='+Math.random()*99999999);document.body.appendChild(e)%7D)());"
      >
        <i class="fab fa-pinterest"></i>
      </a>
      <!-- Twitter -->
      <a
        :href="
          'https://twitter.com/intent/tweet?url=' +
          window.location.href +
          '&amp;text=' +
          company.title
        "
        class="twitter"
        target="_blank"
      >
        <i class="fab fa-twitter"></i>
      </a>
    </div>
    <a
      :class="{
        in: is_favorite,
      }"
      :data-id="company.id"
      class="bordered-btn favorite-btn"
      data-toggle="favorite"
      href="#"
    >
      <span class="icon-saved"></span>
      <span class="__add">{{ $t("Add to favorites") }}</span>
      <span class="__remove">{{ $t("Remove from favorites") }}</span>
    </a>
  </div>
</template>
<script>
export default {
  name: "Actions",
  props: ["company", "is_favorite"],
  data() {
    return {
      window: window,
    };
  },
};
</script>
